import { DESKTOP } from '@/src/constants/deviceTypes'
import { DeviceType } from '@/src/types/deviceType'
import { path } from '../generalUtils/path'

export const getMobileDeviceType = () => {
    const deviceType = null
    if (typeof window === 'undefined') {
        return deviceType
    }
    const userAgent = path(['navigator', 'userAgent'], window)?.toLowerCase()
    const safari = /safari/.test(userAgent) // checks if browser is safari
    const ios = /iphone|ipod|ipad/.test(userAgent) // checks if device is among iphone, ipad or ipod

    if (path(['androidData', 'app-agent'], window) && path(['androidData', 'js-version'], window)) {
        return 'AndroidApp'
    }
    if (
        (path(['iosData', 'app-agent'], window) && path(['iosData', 'js-version'], window)) ||
        (ios && !safari) // checks if device is of ios but not running in safari browser
    ) {
        return 'iPhoneApp'
    }
    if (path(['sessionStorage'], window) && typeof window.sessionStorage != 'undefined') {
        return sessionStorage.getItem('mobileApp')
    }
    return deviceType
}

export const getAppAgent = (deviceType: DeviceType) => {
    if (deviceType === DESKTOP) {
        return deviceType
    }
    let appAgent = 'PWA'
    const mobileDeviceType = getMobileDeviceType()
    if (mobileDeviceType === 'AndroidApp') {
        appAgent = 'AndroidApp'
    } else if (mobileDeviceType === 'iPhoneApp') {
        appAgent =  'iPhoneApp'
    }

    return appAgent
}

export const getPlatformName = (deviceType: DeviceType) => {
    if (deviceType === DESKTOP) {
        return deviceType
    }
    let appAgent = 'PWA'
    const mobileDeviceType = getMobileDeviceType()
    if (mobileDeviceType === 'AndroidApp') {
        appAgent = 'ANDROID'
    } else if (mobileDeviceType === 'iPhoneApp') {
        appAgent =  'IOS'
    }

    return appAgent
}